(function () {
  // Cards and recipe pages are server-rendered (snippets/recipes-pages.liquid, generated by tools\mc.py build).
  // List page (/pages/recipes): filters the cards; old ?r=<slug> links forward to the recipe's blog post.
  // Recipe post (/blogs/recipes/<slug>): fills in the live shop box and loads the reel.
  var root = document.getElementById('rc-root');
  if (!root) return;
  var params = new URLSearchParams(location.search);
  var old = params.get('r');
  if (old) { location.replace('/blogs/recipes/' + encodeURIComponent(old.replace(/^\d{4}-\d{2}-/, ''))); return; }
  var assets = JSON.parse(document.getElementById('rc-assets').textContent);
  var $ = function (id) { return document.getElementById(id); };
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function shopBox(rub, sauce) {
    if (!rub && !sauce) return '';
    // Title, size, price and stock come from the store (Liquid rc-assets), so they stay current.
    var p = assets.products, main, pics, text, label;
    function line(x, fallback) { return [x.title || fallback, x.size, x.price].filter(Boolean).join(', ') + '.'; }
    if (rub && sauce) { main = p.pack; pics = [p.rub.img, p.pack.img]; text = 'Both flavours in ' + line(p.pack, 'the Expedition Pack'); label = 'Shop the Expedition Pack'; }
    else if (rub) { main = p.rub; pics = [p.rub.img]; text = line(p.rub, 'The Adventurer'); label = 'Shop The Adventurer'; }
    else { main = p.sauce; pics = [p.sauce.img]; text = line(p.sauce, 'The Trailblazer'); label = 'Shop The Trailblazer'; }
    if (main.price) label += ' · ' + main.price;
    if (!main.available) { text += ' Sold out right now.'; label = 'Sold out · join the waitlist'; }
    var ph = pics.filter(Boolean).map(function (u) { return '<img src="' + esc(u) + '" alt="">'; }).join('');
    return '<div class="rc-shop"><p class="k">SHOP THIS RECIPE</p>' + (ph ? '<div class="pics">' + ph + '</div>' : '') + '<p>' + esc(text) + '</p><a class="btn-red' + (main.available ? '' : ' is-sold') + '" href="' + esc(main.url) + '">' + esc(label) + '</a></div>';
  }

  var pg = root.querySelector('.rc-page');
  if (pg) {
    var s = pg.querySelector('[data-shop]');
    if (s) s.innerHTML = shopBox(s.getAttribute('data-rub') === 'true', s.getAttribute('data-sauce') === 'true');
    // The reel sits in a <template> so Instagram's embed.js only loads on a recipe page.
    var reel = pg.querySelector('[data-reel] template');
    if (reel) {
      reel.parentNode.appendChild(reel.content.cloneNode(true));
      var js = document.createElement('script');
      js.async = true; js.src = 'https://www.instagram.com/embed.js';
      document.body.appendChild(js);
    }
    return;
  }

  var cur = params.get('f') || 'all';
  function renderList() {
    root.querySelectorAll('#rc-filters button[data-f]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-f') === cur)); });
    var n = 0;
    $('rc-grid').querySelectorAll('.rc-card').forEach(function (c) {
      var on = cur === 'all' || c.getAttribute('data-cat') === cur;
      c.hidden = !on; if (on) n++;
    });
    $('rc-count').textContent = n + (n === 1 ? ' recipe' : ' recipes');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-f]');
    if (b) { cur = b.getAttribute('data-f'); renderList(); }
  });
  renderList();
})();